import { useTranslation } from 'react-i18next';

export const useCardStep = (): {
    getCardStep: (stepNumber: number, totalSteps: number) => string;
} => {
    const { t } = useTranslation();
    return {
        getCardStep: (stepNumber: number, totalSteps: number) =>
            t('SCROLLABLE_AREA.STEPS_COUNTER', { stepNumber, totalSteps }),
    };
};
